var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { Radio as ArcoRadio, ConfigProvider as ArcoConfigProvider } from '@arco-design/web-react';
import { useConfigContext } from '@m4b-design/config-provider';
import cx from 'classnames';
import Child from './children';
import IconHover from './icon-hover';
import './style/radio.less';
var RadioRender = function (props) {
    var _a;
    var icon = props.icon, tooltipContent = props.tooltipContent, description = props.description, children = props.children, _b = props.size, size = _b === void 0 ? 'default' : _b, _c = props.lineFeed, lineFeed = _c === void 0 ? false : _c, _d = props.error, error = _d === void 0 ? false : _d, rest = __rest(props, ["icon", "tooltipContent", "description", "children", "size", "lineFeed", "error"]);
    var ConfigContext = ArcoConfigProvider.ConfigContext;
    var ctx = useContext(ConfigContext);
    var arcoPrefixCls = ctx.prefixCls;
    var arcoRarioPrefixCls = "".concat(arcoPrefixCls, "-radio");
    var arcoRadioBlock = "".concat(arcoPrefixCls, "-radio-flex");
    var globalPrefixCls = useConfigContext().prefixCls;
    var prefixCls = "".concat(globalPrefixCls, "-radio");
    var classNames = cx(props.className, prefixCls, lineFeed && arcoRadioBlock, "".concat(prefixCls, "-size-").concat(size), (_a = {},
        _a["".concat(arcoRarioPrefixCls, "-error")] = error,
        _a));
    if (typeof children === 'function') {
        var radio_1 = (React.createElement(IconHover, { prefix: arcoRarioPrefixCls, className: "".concat(arcoRarioPrefixCls, "-mask-wrapper"), disabled: props.checked || props.disabled },
            React.createElement("div", { className: "".concat(arcoRarioPrefixCls, "-mask") })));
        var newFun = function (_a) {
            var checked = _a.checked;
            return children({ checked: checked, radio: radio_1 });
        };
        return (React.createElement(ArcoRadio, __assign({}, rest, { className: classNames }), newFun));
    }
    var childProps = {
        icon: icon,
        tooltipContent: tooltipContent,
        description: description,
        children: children,
    };
    var isAllUndefined = function (obj) {
        return Object.keys(obj).reduce(function (acc, key) {
            return acc && obj[key] === undefined;
        }, true);
    };
    return (React.createElement(ArcoRadio, __assign({ "data-tid": "m4b_radio" }, rest, { className: classNames }), !isAllUndefined(childProps) && React.createElement(Child, __assign({}, childProps))));
};
var Radio = RadioRender;
Radio.displayName = 'Radio';
export default Radio;
